import { Directive, ViewContainerRef, Input } from '@angular/core';

@Directive({
  selector: '[app-dynamic-fields]'
})
export class DynamicFieldsDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}


// WEBPACK FOOTER //
// ./src/app/forms/dynamic-fields.directive.ts